import { observer } from "mobx-react-lite";
import { Colors } from "../../../utils/colors";
import { ScoreSectionHeader } from "./ScoreSectionHeader";
import { TCText } from "../../../components/TCText/TCText";
import { ScoreSetHeader } from "./ScoreSetHeader";
import { TeamPlayerScore } from "./TeamPlayerScore";
import { VideosSection } from "./VideosSection";
import { useMatchDetailsStore } from "../../../stores/StoreContext";
import Apple from "../../../assets/Apple.png";
import PlayStore from "../../../assets/Playstore.png";
import { useAppPlayStore } from "../../../hooks/useAppPlayStore";

export const ScoreSection = observer(() => {
  const { matchDetails, teamScoreA, teamScoreB, isPromoMode } =
    useMatchDetailsStore();
  const { handleAndroidClick, handleIOSClick } = useAppPlayStore();
  return matchDetails ? (
    <div
      style={{
        width: "100%",
        paddingTop: 5,
        paddingLeft: 5,
        paddingRight: 5,
        paddingBottom: 16,
        backgroundColor: Colors.white,
        borderRadius: 20,
      }}>
      <ScoreSectionHeader
        matchDate={matchDetails?.date}
        showVideoIndicator={matchDetails?.videoIndicator}
      />
      <div
        style={{
          height: "100%",
          width: "100%",
          paddingLeft: 10,
          paddingRight: 10,
        }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: 20,
          }}>
          <TCText
            value="Current Score"
            style={{ fontWeight: 600, fontSize: 14 }}
          />
          {/* <img
            src={ShareIcon}
            alt=""
            style={{
              width: 16,
              height: 16,
              objectFit: "contain", // Ensures the image covers the area
            }}
          /> */}
        </div>
        <ScoreSetHeader />
        <TeamPlayerScore isCurrentUserTeam team={teamScoreA} />
        <TeamPlayerScore team={teamScoreB} />
        {isPromoMode ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              justifyContent: "space-between",
              marginTop: 20,
            }}>
            <TCText
              style={{
                fontWeight: 500,
                fontSize: 12,
              }}
              value="Enter your score in the ULTRA AI Sports App now"
            />
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img
                onClick={handleIOSClick}
                src={Apple}
                alt=""
                style={{
                  width: 22,
                  height: 22,
                  objectFit: "contain", // Ensures the image covers the area
                }}
              />

              <img
                onClick={handleAndroidClick}
                src={PlayStore}
                alt=""
                style={{
                  width: 22,
                  height: 22,
                  objectFit: "contain", // Ensures the image covers the area
                }}
              />
            </div>
          </div>
        ) : null}
        <VideosSection videoData={matchDetails?.videoData ?? []} />
      </div>
    </div>
  ) : null;
});
